module.exports = __webpack_public_path__ + "images/b9c3d1ed.png";